import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import PaymentNotificationMobile from '../../paymentNotificationMobile/PaymentNotificationMobile';
import {
  Amount,
  AmountText,
  Decimal,
  Integer,
  ConcealableWrapper,
  AmountNumber,
  Seller,
} from './ShortDescription.styles';
import { IShortDescription } from './ShortDescription.types';

function ShortDescription(props: IShortDescription): ReactElement {
  const { integers, decimals, currency, progress, shopName, paymentData, concealableWrapperRef } = props;
  return (
    <>
      <Amount>
        <AmountText>
          <FormattedMessage id="statusBar.amountText" />
        </AmountText>
        <AmountNumber>
          <Integer data-testid="statusbar-mobile:integer">{integers}</Integer>
          <Decimal data-testid="statusbar-mobile:decimal">{`,${decimals}${currency}`}</Decimal>
        </AmountNumber>
      </Amount>
      <PaymentNotificationMobile {...paymentData} progress={progress} />
      <ConcealableWrapper ref={concealableWrapperRef}>
        <Seller>
          <FormattedMessage id="statusBar.sellerText" />
          <p data-testid="statusbar-mobile:shop-name">{shopName}</p>
        </Seller>
      </ConcealableWrapper>
    </>
  );
}
export default ShortDescription;
